import { z } from "zod";


const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalBoolean = z.boolean().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalDate = z.coerce.date().nullable().optional();

export const ContratoArquivoSchema = z.object({
  IdContratoArquivo: z.number().int().default(0),
  IdContrato: optionalNumber,
  Descricao: optionalString.pipe(z.string().max(500, "Máximo de 500 caracteres").nullable().optional()),
  Nome: optionalString.pipe(z.string().max(500, "Máximo de 500 caracteres").nullable().optional()),
  Arquivo: z.instanceof(File).nullable().optional(),
  Obsoleto: optionalNumber,
  DataVencimento: optionalDate,
  limparArquivo1: z.coerce.boolean().default(false),
});

export type ContratoArquivoForm = z.infer<typeof ContratoArquivoSchema>;